module.exports = __webpack_public_path__ + "static/media/vaibhavshah.3c490b16.png";